export default {
  default: {
    title: 'Authorize',
    titleSecondLine: 'Integration',
    button: 'Authorize Integration',
  },
}
